import client from 'src/api/client';
import userClient from './userClient';
import mailingClient from './mailingClient';
import goClient from 'src/api/goClient';
import blobStorageClient from 'src/api/blobStorageClient';

const setAuthorizationToken = () => {
  const authToken = localStorage.getItem('AccessToken');
  const permissionToken = localStorage.getItem('PermissionToken');

  if (authToken && permissionToken) {
    client.defaults.headers.common.Authorization = `Bearer ${permissionToken}`;
    userClient.defaults.headers.common.Authorization = `Bearer ${authToken}`;
    mailingClient.defaults.headers.common.Authorization = `Bearer ${authToken}`;
    goClient.defaults.headers.common.Authorization = `Bearer ${authToken}`;
    blobStorageClient.defaults.headers.common.Authorization = `Bearer ${authToken}`;
  } else {
    delete client.defaults.headers.common.Authorization;
    delete userClient.defaults.headers.common.Authorization;
    delete mailingClient.defaults.headers.common.Authorization;
    delete goClient.defaults.headers.common.Authorization;
    delete blobStorageClient.defaults.headers.common.Authorization;
  }
};

export default setAuthorizationToken;
